module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/id_5-e69f1c42ffe1ff004e77ebeb8ad7fc06.jpg";